import { client } from '../../../../../../common-utils/libraries/axios/axios';
import USERS from '../apiUrls';

const mutationActivateUser = (onSuccess, onError) => {
    return {
        mutationFn: (userUuid) => {
            return client.put(USERS.ACTIVATE_USER.url, { uuid: userUuid });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationActivateUser;